import { BRAND } from '../config/branding';

export const mcoTransferInfoUrl = BRAND.urls.mcoTransferInfo;
export const movehqPrivacyPolicyUrl = BRAND.urls.privacyPolicy;
export const hscTosUrl = BRAND.urls.termsOfService;
export const factSheetUrl = BRAND.urls.factSheet;
// TODO: Waiting on HSA for actual urls
export const weightCalculatorUrl =
  'https://www.ustranscom.mil/dp3/weightestimator.cfm';
export const milmovePpmUrl = 'https://my.move.mil/';
export const militaryOneSourceUrl =
  'https://www.militaryonesource.mil/resources/podcasts/military-onesource/personally-procured-moves/';
